import React from "react";
import AccountDetail from "../../../pages/account/accountdetail/accountDetail";
import PersonalDetail from "../../../pages/account/personalDetails/personalDetails";
import LocationDetail from "../../../pages/account/location/locationDetail";

const userDetail = () => {
  return (
    <>
      <AccountDetail />
      <PersonalDetail />
      <LocationDetail />
    </>
  );
};

export default userDetail;
